const parseCookies = () => {
	return Object.fromEntries(document.cookie.split('; ').map(v=>v.split(/=(.*)/s).map(decodeURIComponent)));
};

export const getCookie = name => {
	const cookies = parseCookies();
	return cookies[name];
};

export const setCookie = (cname, cvalue, exdays) => {
	if (exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + encodeURIComponent(cvalue) + ';' + (typeof expires === 'undefined' ? '' : expires) + ';path=/';
	}
	return null;
};
